var exports = {
  "q": "xa15a2ab7--d50534--footer",
  "k": "xa15a2ab7--d50534--container",
};

module.exports = exports;
